import React from 'react';
import { Box, Alert, AlertTitle, Typography } from '@mui/material';

interface ErrorAlertProps {
  error: string | null;
  serviceHealth?: {
    status: string;
    message?: string;
    checks?: any;
  } | null;
}

export const ErrorAlert: React.FC<ErrorAlertProps> = ({ error, serviceHealth }) => {
  if (!error) return null;
  
  return (
    <Alert severity="error" sx={{ mb: 3 }}>
      <AlertTitle>Error</AlertTitle>
      {error}
      {serviceHealth && (
        <Box mt={1} fontSize="0.875rem">
          Service Status: {serviceHealth.status}
          {serviceHealth.message && (
            <Typography variant="body2" mt={0.5}>Details: {serviceHealth.message}</Typography>
          )}
        </Box>
      )}
    </Alert>
  );
};
